import React, { useCallback } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { CustomTextArea } from '../../../common/CustomTextArea';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../actions';
import {
  renderInputField,
  renderInputFieldWithoutLabel,
} from '../../../common/inputField';
import DateComponent from '../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';

const PreviousIVF = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);

  const handleInputChange = useCallback(
    (e, attempt, field) => {
      const { value } = e.target;
      if (attempt == null) {
        dispatch(setPatientData(`patientHistory.previousIVF.${field}`, value));
        return;
      }
      dispatch(
        setPatientData(`patientHistory.previousIVF.${attempt}.${field}`, value),
      );
    },
    [dispatch],
  );

  const handleDateChange = useCallback(
    (date, attempt) => {
      const dateString = date ? date.format('YYYY-MM-DD') : '';
      dispatch(
        setPatientData(
          `patientHistory.previousIVF.${attempt}.date`,
          dateString,
        ),
      );
    },
    [dispatch],
  );

  const fields = [
    { name: 'date', label: 'Date' },
    { name: 'place', label: 'Place' },
    { name: 'protocol', label: 'Protocol' },
    { name: 'typeOfGonadotropin', label: 'Type of Gonadotropin' },
    { name: 'totalStimulationDays', label: 'Total Stimulation Days' },
    { name: 'totalDose', label: 'Total Dose' },
    { name: 'noOfEggs', label: 'No of Eggs' },
    { name: 'noOfEmbryos', label: 'No of Embryos' },
    { name: 'noTransferred', label: 'No Transferred' },
    { name: 'outcome', label: 'Outcome' },
    { name: 'frozen', label: 'Frozen' },
    { name: 'comments', label: 'Comments' },
  ];

  const attempts = ['attempt1', 'attempt2', 'attempt3'];

  return (
    <React.Fragment>
      <p className="lead">DETAILS OF PREVIOUS IVF CYCLES</p>
      {renderInputField(
        'No of cycles',
        'noOfCycles',
        patientData.patientHistory.previousIVF.noOfCycles,
        (e) => handleInputChange(e, null, 'noOfCycles'),
        false,
      )}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>IVF</TableCell>
              {attempts.map((attempt, index) => (
                <TableCell key={index}>{`ATTEMPT ${index + 1}`}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {fields.map((field) => (
              <TableRow key={field.name}>
                <TableCell>{field.label}</TableCell>
                {attempts.map((attempt, index) => (
                  <TableCell key={index}>
                    {field.name === 'date' ? (
                      <DateComponent
                        selectedDate={
                          patientData.patientHistory.previousIVF[attempt].date
                            ? dayjs(
                                patientData.patientHistory.previousIVF[attempt]
                                  .date,
                              )
                            : null
                        }
                        handleDateChange={(date) =>
                          handleDateChange(date, attempt)
                        }
                      />
                    ) : (
                      renderInputFieldWithoutLabel(
                        field.label,
                        patientData.patientHistory.previousIVF[attempt][
                          field.name
                        ],
                        (e) => handleInputChange(e, attempt, field.name),
                      )
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <p className="lead">Comments</p>
      <CustomTextArea
        value={patientData.patientHistory.previousIVF.comments}
        onChange={(e) => handleInputChange(e, 'comments')}
        name="comments"
      />
    </React.Fragment>
  );
};

export default PreviousIVF;
